import { CareType } from '@dokucoach/invoicing-types';
import { array, date, mixed, object, string } from 'yup';
import { values } from '../../enums';

export type IExecutionPlanCreate = {
  planCareType: CareType;
  planUntil: Date;
  residentIds?: string[];
};

export const IExecutionPlanCreateSchema = object({
  planCareType: mixed<CareType>().oneOf(values(CareType)).required(),
  planUntil: date().required(),
  residentIds: array().of(string()).optional(),
});
